import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { add } from 'date-fns';
import { Button, Typography, ArrowRightIcon } from '@ag1/ui';

import { getDurationForSubscription } from 'shared/utils/getDurationForSubscription';
import { useDate } from 'shared/hooks';
import { type DeliveryFrequencyInfoProps } from '../../DeliveryFrequencyV2.types';
import styles from './DeliveryFrequencyInfo.module.scss';

const DeliveryFrequencyInfo = ({
  newDateValue,
  option,
  handleClick,
  showExtraInfo,
  className
}: DeliveryFrequencyInfoProps) => {
  const { t } = useTranslation('modalWindows');
  const interval = Number(option);
  const period = 'days';

  const { formattedDateString: formattedOrderDate } = useDate({
    date: newDateValue,
    dateFormat: 'MMM d'
  });

  const { formattedDateString: formattedNextOrderDate } = useDate({
    date: newDateValue,
    dateFormat: 'MMM d',
    processDate: (date) => add(new Date(date * 1000), getDurationForSubscription(interval, period))
  });

  if (!newDateValue) return null;

  return (
    <div className={clsx(styles.root, className)}>
      <div className={styles.wrapper}>
        <div className={styles.textWrapper}>
          <Typography
            variant="body"
            size="3"
            component="p"
            color="black-new"
            noPadding
            className={styles.label}>
            {t('editFrequency.nextOrder')}
          </Typography>
          <Typography
            variant="body"
            size="1"
            component="p"
            color="black-new"
            noPadding
            className={styles.orderDate}>
            {formattedOrderDate}
          </Typography>
        </div>
        <ArrowRightIcon className={styles.arrow} />
        <div className={styles.textWrapper}>
          <Typography
            variant="body"
            size="3"
            component="p"
            color="black-new"
            noPadding
            className={styles.label}>
            {t('editFrequency.followedBy')}
          </Typography>
          <Typography
            variant="body"
            size="1"
            component="p"
            color="black-new"
            noPadding
            className={styles.nextOrderDate}>
            {formattedNextOrderDate}
          </Typography>
        </div>
      </div>
      {showExtraInfo && (
        <Typography
          variant="body"
          size="2"
          component="p"
          color="black-new"
          noPadding
          className={styles.extraInfo}>
          {t('editFrequency.extraInfo')}
        </Typography>
      )}
      {handleClick && (
        <Button variant="link" onClick={handleClick} size="small" className={styles.link} noPadding>
          {t('editFrequency.nextOrderLink')}
        </Button>
      )}
    </div>
  );
};

export default DeliveryFrequencyInfo;
